import React from 'react'
import Logo from "../asset/img/logo.png"

const Header = () => {
    return (
        <>
            <nav className="navbar navbar-expand-lg bg-body-tertiary header-content py-4 shadow-sm" id='header'>
                <div className="container">
                    <a className="navbar-brand" href="#banner">
                        <img src={Logo} alt="logo" width="175px" />
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link" href="#banner">Ana Sayfa</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#info">Hizmetlerimiz</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href='#single-info'>Neden Biz ?</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href='#about-us'>Hakkımızda</a>
                            </li>
                        </ul>
                        {/* <button className='btn btn-primary-v2'>
                            <a href='#contact' className='text-decoration-none text-white'>İletişim</a>
                        </button> */}
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Header